<div class="min-h-1/4">
    <lib-data-management-tree
        [editMode]="false"
        [selectedNodeId]="selectedNodeId()"
        [mdoSystems]="mdoSystems()"
        [dataManagementData]="dataManagementData()"
        [translocoContent]="translocoContent()"
        [canChangeTreeNodeSelection]="canChangeTreeNodeSelection.bind(this)"
        (treeNodeSelection)="treeNodeSelected($event)"></lib-data-management-tree>
</div>
